import { render, staticRenderFns } from "./CurrentMonthPreviousYearConsumptionComparison.vue?vue&type=template&id=59f671a2&lang=pug&"
import script from "./CurrentMonthPreviousYearConsumptionComparison.vue?vue&type=script&lang=ts&"
export * from "./CurrentMonthPreviousYearConsumptionComparison.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports